import React from "react";
import { Modal } from "react-bootstrap";
import "./style.css";

function SearchModal(props) {
  const handleClose = () => {
    props.setPaymentOpen(false);
  };

  return (
    <Modal
      {...props}
      show={props.paymentOpen}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="custom-search-modal"
    >
      <Modal.Body className="search-modal-body">
        {/* Search Header Input Area */}
        <div className="search-modal-header">
          <div className="search-input-wrapper">
            <i className="fa fa-search search-input-icon"></i>
            <input
              type="text"
              className="search-input-field"
              placeholder="Search directory, pages, listings..."
              value={props?.searchQuery}
              onChange={props?.handleSearchChange}
              autoFocus
            />
            {props?.searchQuery && (
              <button
                className="search-clear-btn"
                onClick={() => props.handleSearchChange({ target: { value: "" } })}
                aria-label="Clear Search"
              >
                <i className="fa fa-times"></i>
              </button>
            )}
          </div>
          <button className="search-close-btn" onClick={handleClose} aria-label="Close modal">
            <i className="fa fa-times"></i>
          </button>
        </div>

        {/* Search Results Area */}
        <div className="search-results-container">
          {props?.searchResults?.length > 0 ? (
            <div className="search-results-list">
              <div className="search-results-count">
                Found {props.searchResults.length} {props.searchResults.length === 1 ? 'result' : 'results'}
              </div>
              {props.searchResults.map((result, i) => (
                <div
                  key={result.id || i}
                  className="search-result-row"
                  onClick={() => props.handleResultClick(result)}
                >
                  <div className="result-info">
                    <span className="result-number">{(i + 1).toString().padStart(2, '0')}</span>
                    <span className="result-name">{result?.name}</span>
                  </div>
                  <i className="fa fa-chevron-right result-arrow-icon"></i>
                </div>
              ))}
            </div>
          ) : (
            <div className="search-empty-state">
              <div className="empty-state-icon-wrapper">
                <i className="fa fa-search-plus empty-state-icon"></i>
              </div>
              <p className="empty-state-title">
                {props?.searchQuery ? "No results found" : "Looking for something?"}
              </p>
              <p className="empty-state-description">
                {props?.searchQuery 
                  ? `We couldn't find any listings matching "${props.searchQuery}"`
                  : "Type to search Kerala Spacepark directory, registers, and resources."}
              </p>
            </div>
          )}
        </div>
        
        {/* Footer shortcuts */}
        <div className="search-modal-footer">
          <span className="footer-shortcut"><kbd>ESC</kbd> to close</span>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SearchModal;
